import { PROPOSAL_STATUS_TRANSLATION } from '@/types/ProposalStatusTranslation'
import { PROPOSTA_SITUACOES } from '@/types/PropostaSituacoes'
import { PROPOSTA_STATUS } from '@/types/PropostaStatus'
import { IProposta } from '@/interfaces'
export class PropostaHelper {

	static readonly PROPOSAL_CANCELLED_BY_BANK = "Cancelled by bank";

	/**
	 * Return the description of the proposal situation
	 * @param situacao
	 * @returns the description of the proposal situation
	 */
	static getSituacaoDescricao(situacao: PROPOSTA_SITUACOES) {
		switch (situacao) {
			case PROPOSTA_SITUACOES.ANDAMENTO:
				return 'Andamento'
			case PROPOSTA_SITUACOES.APROVADO:
				return 'Aprovado'
			case PROPOSTA_SITUACOES.PENDENTE:
				return 'Pendente'
			case PROPOSTA_SITUACOES.REPROVADO:
				return 'Reprovado'
			case PROPOSTA_SITUACOES.CANCELADO:
				return 'Cancelado'
			case PROPOSTA_SITUACOES.FINALIZADO:
				return 'Finalizado'
			case PROPOSTA_SITUACOES.EM_ANALISE:
				return 'Em Análise'
			case PROPOSTA_SITUACOES.ANALISE_ATTA:
				return 'Análise Mesa Operações'
			case PROPOSTA_SITUACOES.ANALISE_BANCO:
				return 'Análise Banco'
			case PROPOSTA_SITUACOES.ANALISE_BANCO_DUVIDA:
				return 'Análise Banco Dúvida'
			case PROPOSTA_SITUACOES.NAO_PASSIVEL_DEFESA:
				return 'Não defensável'
			case PROPOSTA_SITUACOES.REVISAO:
				return 'Em Revisão'
			case PROPOSTA_SITUACOES.NAO_PROCESSADO_BANCO:
				return 'Não processado'
			case PROPOSTA_SITUACOES.DIVERGENCIA_CADASTRO:
				return 'Divergência Cadastro'
			case PROPOSTA_SITUACOES.NOTAS_DE_EXIGENCIA:
				return 'Notas de Exigência'
			case PROPOSTA_SITUACOES.CARTORIO_EXTERNO:
				return 'Cartório Externo'
			case PROPOSTA_SITUACOES.APROVADO_CONDICIONADO:
				return 'Aprovado - Condicionado'

			default:
				return '-'
		}
	}

	/**
	 * Return the description of the proposal status
	 * @param status
	 * @returns the description of the proposal status
	 */
	static getStatusDescricao(status: PROPOSTA_STATUS) {
		switch (status) {
			case PROPOSTA_STATUS.CARTA_CREDITO:
				return 'Carta de Crédito'
			case PROPOSTA_STATUS.CHECKLIST:
				return 'Checklist'
			case PROPOSTA_STATUS.CONF_EMISSAO:
				return 'Conf / Emissão'
			case PROPOSTA_STATUS.CONTRATACAO:
				return 'Contratação'
			case PROPOSTA_STATUS.CONTRATADO:
				return 'Contratado'
			case PROPOSTA_STATUS.PRE_ANALISE:
				return 'Pré-análise'
			case PROPOSTA_STATUS.VISTORIA:
				return 'Vistoria'
			case PROPOSTA_STATUS.CARTORIO:
				return 'Cartório'
		}
	}

	/**
	 * Function to verify if the element is a tag or string
	 * created to customize the new highlight
	 * @param str : string
	 */
	static isHTML(str: string) {
		let element = document.createElement('div')
		element.innerHTML = str

		for (let c = element.childNodes, i = c.length; i--; ) {
			if (c[i].nodeType == 1) return true
		}

		return false
	}

	/**
	 * Return the description of the proposal statusstranslation
	 * @param status_translation
	 * @returns the description of the proposal status
	 */
	static getStatusTranslationDescription(status: PROPOSAL_STATUS_TRANSLATION) {
		switch (status) {
			case PROPOSAL_STATUS_TRANSLATION.CreditApproved:
				return 'Crédito aprovado. Entre em contato com o comprador para ajuda-lo a escolher o banco.'
			case PROPOSAL_STATUS_TRANSLATION.CreditRefused:
				return 'Crédito recusado'
			case PROPOSAL_STATUS_TRANSLATION.ProposalCancelled:
				return 'Proposta cancelada'
			case PROPOSAL_STATUS_TRANSLATION.ProposalExpired:
				return 'Proposta vencida'
			case PROPOSAL_STATUS_TRANSLATION.ProposalNotStarted:
				return 'Proposta não iniciada'
			case PROPOSAL_STATUS_TRANSLATION.CreditAnalysisInProgress:
				return 'Análise de crédito do comprador em andamento.'
			case PROPOSAL_STATUS_TRANSLATION.FinancingProcessBlocked:
				return 'Houve algum impedimento no processo de financiamento.'
			case PROPOSAL_STATUS_TRANSLATION.FinancingProcessCompleted:
				return 'Processo de financiamento concluído'
			case PROPOSAL_STATUS_TRANSLATION.LegalAnalysisInProgress:
				return 'Análise jurídica do comprador e do vendedor em andamento.'
			case PROPOSAL_STATUS_TRANSLATION.RegistrationFinancingContractApproved:
				return 'Registro do contrato de financiamento aprovado pelo banco.'
			case PROPOSAL_STATUS_TRANSLATION.WaitingForReleaseResources:
				return 'Aguardando liberação de recurso para pagamento do vendedor.'
			case PROPOSAL_STATUS_TRANSLATION.BankReanalyzingDocumentsSent:
				return 'O banco está efetuando uma reanálise dos documentos enviados.'
			case PROPOSAL_STATUS_TRANSLATION.BankWaitingForDocumentsLegalAnalysis:
				return 'O banco está aguardando o envio de documentos para análise jurídica.'
			case PROPOSAL_STATUS_TRANSLATION.BankWaitingForPendingDocumentsLegalAnalysis:
				return 'O banco está aguardando o envio dos documentos pendentes para análise jurídica.'
			case PROPOSAL_STATUS_TRANSLATION.BankWaitingForResentDocumentsLegalAnalysis:
				return 'Erro em algum dos documentos enviados. O banco está aguardando o reenvio de documentos para análise juridica.'
			case PROPOSAL_STATUS_TRANSLATION.BankWaitingForDocumentsCreditAnalysis:
				return 'O banco está aguardando o envio de documentos para prosseguir com a análise de crédito.'
			case PROPOSAL_STATUS_TRANSLATION.BankWaitingCaixaForReleaseFGTS:
				return 'O banco está aguardando o retorno ca CAIXA para a liberação do FGTS do comprador.'
			case PROPOSAL_STATUS_TRANSLATION.BankReviewingInformationToPrepareFinancingContract:
				return 'O banco está revisando as informações para elaborar o contrato de financiamento.'
			case PROPOSAL_STATUS_TRANSLATION.BankPreparingFiduciaryLienContract:
				return 'O banco está preparando o contrato do Interveniente Quitante.'
			case PROPOSAL_STATUS_TRANSLATION.BankWaitingConfirmationFinancingAmountsByBuyer:
				return 'O banco está aguardando a confirmação de valores do financiamento pelo comprador.'
			case PROPOSAL_STATUS_TRANSLATION.BankPreparingFinancingContract:
				return 'O banco está preparando o contrato de financiamento.'
			case PROPOSAL_STATUS_TRANSLATION.BankWaitingFinancingContractSignedByAllParties:
				return 'O banco está aguardando o retorno do contrato de financiamento assinado por todas as partes.'
			case PROPOSAL_STATUS_TRANSLATION.BankWaitingFiduciaryLienContractSignedByAllParties:
				return 'O banco está aguardando o retorno do contrato de Interveniente Quitante assinado por todas as partes.'
			case PROPOSAL_STATUS_TRANSLATION.BankWaitingInterbankPayment:
				return 'O banco está aguardando o retorno do CIP com as informações do saldo devedor do financiamento anterior.'
			case PROPOSAL_STATUS_TRANSLATION.WaitingValidationFinancingContractRegistrationNotaryOffice:
				return 'Aguardando a validação do registro do contrato de financiamento no Cartório.'
			case PROPOSAL_STATUS_TRANSLATION.WaitingRegistrationFinancingContractNotaryOffice:
				return 'Aguardando o registro do contrato de financiamento no Cartório.'
			case PROPOSAL_STATUS_TRANSLATION.WaitingValidationFinancingContractRegistrationByBank:
				return 'Aguardando a validação do registro do contrato de financiamento pelo banco.'

			default:
				return '---'
		}
	}

	static proposalCancelledByBankStatusText() : string {
		return 'Proposta cancelada pelo banco. Entenda com o banco se é possível reverter o cancelamento antes de prosseguir.';
	}
}
